module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pitch-mission-statement"
  }, [_c('h1', [_vm._v("Develteam Features")]), _vm._v(" "), _c('div', {
    staticClass: "features"
  }, _vm._l((_vm.features), function(feature) {
    return ((_vm.depth === 'short' && feature.short) || (_vm.depth === 'long' && feature.long) || _vm.depth === 'both') ? _c('div', {
      staticClass: "feature"
    }, [_c('h1', [_vm._v(_vm._s(feature.title))]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(feature.content)
      }
    })]) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e25f312!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/HomeDashboard/Pitches.vue
// module id = 858
// module chunks = 2